import { useLayoutEffect, useSyncExternalStore } from 'react';

import {
  hasUnsentFolioMessage,
  holdUnsentFolioMessage,
  subscribeToUnsentFolioMessage,
} from '@/lib/unsent-folio-message';

/**
 * Holds Sean's composer draft as unsent while it has text; sending or
 * clearing it releases the hold. A layout effect, so a composer that
 * navigation removes lets go before the next page's error boundary asks
 * (React runs layout cleanups of removed components before
 * `componentDidCatch` in the same commit; passive cleanups run after it).
 */
export function useUnsentFolioMessage(draft: string): void {
  const unsent = draft.trim().length > 0;
  useLayoutEffect(() => (unsent ? holdUnsentFolioMessage() : undefined), [unsent]);
}

/** Whether Sean's composer holds an unsent message, kept current as the user types, sends or clears it. */
export function useHasUnsentFolioMessage(): boolean {
  return useSyncExternalStore(subscribeToUnsentFolioMessage, hasUnsentFolioMessage);
}
